import Accordion from "./Accordion";

const FaqData = ({ searchQuery }) => {
  const faqs = [
    {
      title: "How to add a team member?",
      content:
        "Go to the teams page.Click on the add team button. Follow the instructions and enter the required details to add team members",
    },
    {
      title: "Can I create a prediction model",
      content:
        "Yes. To create a model, on the dashboard click on create model. After which you will be required to enter the model name and set the parameters needed to predict the loan default",
    },
    {
      title: "Can I change my email address after being added by an admin",
      content: "No, you can not change your email address ",
    },
    {
      title: "How will the added team members join the platform?",
      content:
        "An invite link will be sent to the teams member email address.The added team member should click on the invite link to set their password and log into the platform",
    },
    {
      title: "Can i restore an already deleted model?",
      content:
        "We are sorry for the inconvenience. Once a file is deleted, it can b restored. that's why we advice you to deactivate models until you are sure you want to delete it for good",
    },
  ];

  // Filter the FAQ items based on the search query
  const filteredFaqs = faqs.filter((faq) =>
    faq.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      {filteredFaqs.map((faq, index) => (
        <Accordion key={index} title={faq.title} content={faq.content} />
      ))}
    </div>
  );
};

export default FaqData;
